// extracted by mini-css-extract-plugin
export default {"CenterButton":"DownloadDocumentDialog_CenterButton__pZIB+"};